import { Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ModalService } from 'src/app/services/modal/modal.service';
import { PatientService } from 'src/app/services/patient/patient.service';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { FichePatient } from 'src/app/utils/interfaces/new/fiche-patient.interface';
import { ResultatPatient } from 'src/app/utils/interfaces/new/resultat-patient.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search-patients',
  templateUrl: './search-patients.fragment.html',
  styleUrls: [
    './search-patients.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class SearchPatientsFragment implements OnInit, OnDestroy {

  @ViewChild('modalBody') public modalBody: ElementRef;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target)) {
      this.closeSearchPatients();
    }
  }

  @Output() public closeEmitter = new EventEmitter();

  public inputSearchForm: FormGroup;
  private _formChangeSubscribeValue: Subscription;

  public patientSearchList: Array<ResultatPatient> = [];
  public selectedPatient: FichePatient;
  public isSearching = false;
  public searchingMessage = false;
  
  constructor(
    private _formBuilder: FormBuilder,
    private modalSrv: ModalService,
    private viewContainerRef: ViewContainerRef,
    private patientSrv: PatientService,
  ) { }

  ngOnInit(): void {
    this._initForm();
  }

  ngOnDestroy() {
    if (this._formChangeSubscribeValue) {
      this._formChangeSubscribeValue.unsubscribe();
    }
  }

  private _initForm(): void {
    this.inputSearchForm = this._formBuilder.group({
      searchInput: ['']
    });

    this._formChangeSubscribeValue = this.inputSearchForm.valueChanges.pipe(debounceTime(500)).subscribe(async (event) => {
      await this._doSearchPatient(event.searchInput);
    });

    setTimeout(() => {
      const input = document.getElementById('search-input');
      if (input) {
        input.focus();
      }
    }, 50);
  }


  private async _doSearchPatient(event: string) {
    try {
      if (event === '') {
        this.patientSearchList = [];
        this.searchingMessage = false;
        return;
      }
  
      const words = event.trim().split(/\s+/).join(' '); // Séparer par espaces

      const result = await this.patientSrv.patientsInlineSearch(words, {
        perpage: -1,
        currentPage: 1,
        sortOrder: SortEnum.ASC,
        sortBy: 'nom'
      });

      console.log(result);

      this.patientSearchList = result.objects;
  
      this.searchingMessage = result.objects.length === 0;
      this.isSearching = false;
    } catch (e) {
      this._showAlert();
    }
  }
  

  public async selectPatient(patientId: string) {
    try {
      this.patientSearchList = [];
      this.inputSearchForm.get('searchInput').patchValue('');
      this.selectedPatient = await this.patientSrv.findOnePatientFiche(patientId);
    } catch (e) {
      this._showAlert();
    }
  }

  closeSearchPatients(value?: any) {
    if (value) {
      this.closeEmitter.emit(value);
    } else {
      this.closeEmitter.emit();
    }
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }

  private _showAlert(msg?: string): void {
    msg = msg ? msg : 'Une erreur est survenue lors de la récupération des informations de cette page';

    this.modalSrv.openAlert(this.viewContainerRef, 'Erreur', msg);
  }
}
